import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Schedule } from '@mui/icons-material';
import BookAppointmentModal from './BookAppointmentModal';

interface BookCaretakerButtonProps {
  caretakerId: string;
  caretakerName: string;
  caretakerAvatar?: string;
}

const BookCaretakerButton: React.FC<BookCaretakerButtonProps> = ({ 
  caretakerId, 
  caretakerName, 
  caretakerAvatar 
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        fullWidth
        startIcon={<Schedule />}
        onClick={handleOpen}
        sx={{ mb: 1 }}
      >
        Book Appointment
      </Button>

      <BookAppointmentModal
        open={open}
        onClose={handleClose}
        caretakerId={caretakerId}
        caretakerName={caretakerName}
        caretakerAvatar={caretakerAvatar}
      />
    </>
  );
};

export default BookCaretakerButton;
